module.exports = __webpack_public_path__ + "img/42.d79c7d1d.jpg";